<template>
  <div class="flex flex-column">

    <h1 class="db ph3 pt2 f4">Общие показатели</h1>
    <div class="dashboard-matrix-cards-container">
      <procedures-new-summary />
      <procedures-new-periods />

      <procedures-new-summary-money />
      <procedures-new-periods-money/>

      <main-eco-effect-summary />
      <main-eco-effect-period />
    </div>

    <h1 class="db ph3 pt2 f4">Усредненные показатели</h1>

    <div class="dashboard-matrix-cards-container">
      <offers-average />
      <external-offers-average />
      <average-procedure-active />
      <average-procedure-duration />
      <invited-companies-by-organizer />
      <invited-companies-by-t-pro />

      <one-participant-procedures />
      <not-min-price-procedures />
      <canceled-procedures />
      <canceled-by-org-procedures />
    </div>

  </div>
</template>

<script>
import ProceduresNewSummary from '@/components/dashboard/efficiency/ProceduresNewSummary.vue'
import ProceduresNewPeriods from '@/components/dashboard/efficiency/ProceduresNewPeriods.vue'

import ProceduresNewSummaryMoney from '@/components/dashboard/efficiency/ProceduresNewSummaryMoney.vue'
import ProceduresNewPeriodsMoney from '@/components/dashboard/efficiency/ProceduresNewPeriodsMoney.vue'

import MainEcoEffectSummary from '@/components/dashboard/efficiency/MainEcoEffectSummary.vue'
import MainEcoEffectPeriod from '@/components/dashboard/efficiency/MainEcoEffectPeriod.vue'

import OffersAverage from '@/components/dashboard/efficiency/OffersAverage.vue'
import ExternalOffersAverage from '@/components/dashboard/efficiency/ExternalOffersAverage.vue'
import AverageProcedureActive from '@/components/dashboard/efficiency/AverageProcedureActive.vue'
import AverageProcedureDuration from '@/components/dashboard/efficiency/AverageProcedureDuration.vue'
import InvitedCompaniesByOrganizer from '@/components/dashboard/efficiency/InvitedCompaniesByOrganizer.vue'
import InvitedCompaniesByTPro from '@/components/dashboard/efficiency/InvitedCompaniesByTPro.vue'
import OneParticipantProcedures from '@/components/dashboard/efficiency/OneParticipantProcedures.vue'
import CanceledProcedures from '@/components/dashboard/efficiency/CanceledProcedures.vue'
import NotMinPriceProcedures from '@/components/dashboard/efficiency/NotMinPriceProcedures.vue'
import CanceledByOrgProcedures from '@/components/dashboard/efficiency/CanceledByOrgProcedures.vue'

export default {
  components: {
    MainEcoEffectSummary,
    MainEcoEffectPeriod,
    ProceduresNewSummary,
    ProceduresNewPeriods,
    ProceduresNewSummaryMoney,
    ProceduresNewPeriodsMoney,
    OffersAverage,
    ExternalOffersAverage,
    AverageProcedureActive,
    AverageProcedureDuration,
    InvitedCompaniesByOrganizer,
    InvitedCompaniesByTPro,
    OneParticipantProcedures,
    CanceledProcedures,
    NotMinPriceProcedures,
    CanceledByOrgProcedures
  }
}
</script>

<style lang="scss" scoped>
.dashboard-matrix-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-column-gap: .7rem;
  grid-row-gap: .7rem;
  margin: .7rem;
  justify-items: stretch;
}
@media screen and (min-width: 60em) {
  .dashboard-matrix-cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    grid-column-gap: .7rem;
    grid-row-gap: .7rem;
    margin: .7rem;
    justify-items: stretch;
  }
}
</style>
